import React, { useState } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  dir: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  question: PropTypes.shape({
    answerCount: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
    })).isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
  strings: PropTypes.shape({
    submit: PropTypes.string,
  }).isRequired,
};

const MultipleChoiceQuestion = ({
  dir = null,
  onSubmit,
  question,
  strings,
}) => {
  const [selectedOptionIds, setSelectedOptionIds] = useState([]);

  const fieldType = (question.answerCount === 1) ? 'radio' : 'checkbox';

  const handleSelect = event => {
    const optionId = parseInt(event.target.value, 10);
    const existingPos = selectedOptionIds.indexOf(optionId);
    const excludeExisting = (_, index) => index !== existingPos;

    if (question.answerCount === 1) {
      setSelectedOptionIds([optionId]);
    } else if (existingPos !== -1) {
      setSelectedOptionIds(oldValue => oldValue.filter(excludeExisting));
    } else if (selectedOptionIds.length < question.answerCount) {
      setSelectedOptionIds(oldValue => oldValue.concat([optionId]));
    }
  };

  const handleSubmit = () => {
    onSubmit(question.id, { selectedOptionIds });
  };

  return (
    <div className="question question--multiple" dir={dir}>
      <p className="question__body">
        {question.text}
      </p>

      <div className="question__answers">
        <ul className="list-unstyled">
          {question.options.map(({ id, text }) => (
            <li key={id}>
              <label
                className="question__option"
                htmlFor={`question_option_${id}`}
              >
                <input
                  checked={selectedOptionIds.indexOf(id) !== -1}
                  id={`question_option_${id}`}
                  onChange={handleSelect}
                  type={fieldType}
                  value={id}
                />
                <span
                  className={`question__option-marker question__option-marker--${fieldType}`}
                />
                {text}
              </label>
            </li>
          ))}
        </ul>

        <button
          className="question__btn"
          data-test="questionSubmitButton"
          onClick={handleSubmit}
          type="button"
        >
          {strings.submit}
        </button>
      </div>
    </div>
  );
};

MultipleChoiceQuestion.propTypes = propTypes;

export default MultipleChoiceQuestion;
